export enum TerminationReasonType {
  UMZUG = "UMZUG",
  ABSCHLUSS = "ABSCHLUSS",
  ABGAENGER = "ABGAENGER",
  SONSTIGES = "SONSTIGES",
  ANTRAGSTELLER = "ANTRAGSTELLER"
}
